{
  "rooms": "Räume",
  "new_room": "Neuer Raum",
  "rename_room": "Raum umbenennen",
  "delete_room": "Raum löschen",
  "delete_room_confirm": "Raum „{{name}}\" wirklich löschen? Das entfernt ihn für alle.",
  "room_name": "Raumname",
  "members_csv": "Mitglieder (Komma-getrennt)",
  "create": "Anlegen",
  "no_rooms": "Noch keine Räume",
  "discover": "Entdecken",
  "join_room": "Raum beitreten",
  "join": "Beitreten",
  "visibility_private": "Privat",
  "visibility_open": "Offen",
  "members": "Mitglieder",
  "no_members": "Keine Mitglieder",
  "online": "Online",
  "offline": "Offline",
  "add_member": "Mitglied hinzufügen",
  "remove_member": "Mitglied entfernen",
  "member_username": "Benutzername",
  "add": "Hinzufügen",
  "agents": "Agenten",
  "attach_agent": "Agent zuschalten",
  "detach_agent": "Agent entfernen",
  "no_agents": "Kein Agent zugeschaltet",
  "no_available_agents": "Keine weiteren Agenten verfügbar",
  "no_messages": "Noch keine Nachrichten — schreib etwas.",
  "input_placeholder": "Nachricht… (@name spricht einen Agenten an)",
  "address": "Ansprechen",
  "send": "Senden",
  "not_configured": "Team-Chat ist nicht aktiviert",
  "not_configured_hint": "Der Matrix-Homeserver (tuwunel) ist nicht erreichbar oder der Team-Chat ist ausgeschaltet.",
  "to_extensions": "Zu den Extensions",
  "no_room_selected": "Kein Raum ausgewählt",
  "no_room_selected_hint": "Wähle links einen Raum oder leg einen neuen an."
}
